import React from "react";
export var usePlaylistGenres = function (entries) {
    return React.useMemo(function () {
        if (!entries)
            return "";
        var genres = new Set(entries.flatMap(function (entry) {
            if (entry.type === "private")
                return [];
            return entry.genres.map(function (genre) { return genre.title; });
        }));
        return Array.from(genres);
    }, [entries]);
};
